import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ReactComponent as MascotReport } from '../../assets/mascotReport.svg'
import { fsColors } from '../../shared/constants'

const FsReportEmptyState = () => {
  const { t } = useTranslation()

  return (
    <Stack
      alignItems="center"
      direction="column"
      width="100%"
      sx={{
        border: 3,
        borderColor: fsColors.fsDarkBlue.colors[2],
        borderRadius: 2,
        padding: 5,
        gap: 2,
      }}
    >
      <Typography variant="h6">{t('start.report')}</Typography>
      <MascotReport />
    </Stack>
  )
}

export default FsReportEmptyState
